var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app',[_c('crumb-bar'),_c('menu-aside',[(_vm.chartData)?_c('chart',{attrs:{"type":"bar","data":_vm.chartData,"height":"375"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }